import { documentsFetch, notesFetch, kbArticlesFetch } from '../functions/index.js'

export const home = {
  extends: 'AppPage',
  metadata: { title: 'Documents / Symbols Workspace' },

  onInit: (el, s) => {
    if (el.call('redirectIfExternalOnly', s)) return
  },

  fetch: [
    documentsFetch,
    notesFetch,
    kbArticlesFetch
  ],

  onCreate: (el) => {
    el._presenceUnsub = el.call('useOnlinePresence', { app: 'documents' })
  },
  onRemove: (el) => {
    if (el._presenceUnsub) el._presenceUnsub()
  },

  DocsSidebar: {},
  DocsMain: {}
}
